import styled from 'styled-components';
import { HomePageOptionsCardStyled } from '../HomePageOptionsCardStyled';

export const HomePageOptionsCardStyledDS = styled(HomePageOptionsCardStyled)`
    font-family: ${({ theme }) => theme.fonts.fontBase};

    button {
        width: 100%;
        background-color: ${({ theme }) => theme.colors.coffee};
        color: ${({ theme }) => theme.colors.cream};

        &:hover {
            background-color: ${({ theme }) => theme.colors.coffeeSpilled};
        }
    }

    &.offer-card {
        .home-optionCard--image {
            transform: scaleX(-1);
        }
    }
`;
